import { Stack, Typography, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";

const YesNoStyledSwitch = styled(Switch)(({ theme }) => ({
  width: 72,
  height: 34,
  padding: 7,

  "& .MuiSwitch-switchBase": {
    padding: 9,
    "&.Mui-checked": {
      transform: "translateX(38px)",
      color: "#fff",

      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,

        "&:before": {
          content: '"Yes"',
          left: 10,
        },
        "&:after": {
          content: '""',
        },
      },
    },
  },

  "& .MuiSwitch-thumb": {
    width: 16,
    height: 16,
  },

  "& .MuiSwitch-track": {
    borderRadius: 20,
    position: "relative",
    backgroundColor: theme.palette.grey[400],
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 200,
    }),

    "&:before, &:after": {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#fff",
      fontSize: 12,
      fontWeight: 600,
    },

    "&:before": {
      content: '""',
      left: 10,
    },

    "&:after": {
      content: '"No"',
      right: 10,
    },
  },
}));

type YesNoSwitchProps = {
  label?: string;
  value?: boolean;
  onChange: (value: boolean) => void;
  error?: string;
};

export const YesNoSwitch = ({
  label,
  value,
  onChange,
}: YesNoSwitchProps) => {
  return (
    <Stack spacing={0.5} direction="row">
      {label && <Typography variant="body2" alignContent="center">{label}</Typography>}

      <YesNoStyledSwitch
        checked={!!value}
        onChange={(e) => onChange(e.target.checked)}
      />
    </Stack>
  );
};